import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { AccountDetail, Profile } from '@core/models'
import { LoggerService } from '@core/services/logger.service'
import { environment } from '@environment/environment'
import { Observable, catchError, throwError } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class AccountsApiService {
    private apiUrl = `${environment.serviceUrl}`
    private http = inject(HttpClient)
    private loggerService = inject(LoggerService)

    getUserDetails(id: string): Observable<AccountDetail> {
        return this.http.get<AccountDetail>(`${this.apiUrl}/accounts/${id}/details`).pipe(
            catchError((err) => {
                const errorObj = {}
                console.log(err)
                this.loggerService.logError('', '', '')
                return throwError(() => err)
            }),
        )
    }

    getProfile(id: string): Observable<Profile> {
        return this.http.get<Profile>(`${this.apiUrl}/accounts/${id}/profile`)
    }

    getAllAccounts() {
        return this.http.get(`${this.apiUrl}/accounts/`)
    }

    getCurrentUserID(): Observable<Profile> {
        return this.http.get<Profile>(`${this.apiUrl}/accounts/my-profile`)
    }

    public shouldChangeUsername() {
        return this.http.get<boolean>(`${this.apiUrl}/accounts/should-change-username`)
    }
}
